import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeductivaService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  //Catalogo de deductivas

  getAlldeductivas(token: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/deductive/all`, body, { headers });
  }


  getYears(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/deductive/year`, { headers });
  }

  createdeductiva(deductiva: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/deductive`, deductiva, { headers });
  }

  editdeductiva(deductiva: any, deductivaId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/deductive/${deductivaId}`, deductiva, { headers });
  }

  deletedeductiva(deductivaId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/deductive/${deductivaId}`, { headers });
  }

  //Catalogo de penalizacion

  getAllpenalizacion(token: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/penalyzation/all`, body, { headers });
  }

  createpenalizacion(penalizacion: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/penalyzation`, penalizacion, { headers });
  }

  editpenalizacion(penalizacion: any, penalizacionId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/penalyzation/${penalizacionId}`, penalizacion, { headers });
  }

  deletepenalizacion(penalizacionId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/penalyzation/${penalizacionId}`, { headers });
  }
  
      // Documentos

      SaveDocumentDP(document: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
        return this.http.post(`${this.apiUrl}/deductive/newDocument`, document, { headers });
      }

      getDocs(deductivaId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.get(`${this.apiUrl}/deductive/allDocuments/${deductivaId}`, { headers });
      }

      deleteDoc(deductivaId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.delete(`${this.apiUrl}/deductive/deleteDocument/${deductivaId}`, { headers });
      }

      //VoBo

      VoboD(deductiva: any, deductivaId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.put(`${this.apiUrl}/deductive/VoBo/${deductivaId}`, deductiva, { headers });
      }

      ComentariosD(deductiva: any, deductivaId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.put(`${this.apiUrl}/deductive/Observations/${deductivaId}`, deductiva, { headers });
      }

      VoboP(penalizacion: any, penalizacionId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.put(`${this.apiUrl}/penalyzation/VoBo/${penalizacionId}`, penalizacion, { headers });
      }

      ComentariosP(penalizacion: any, penalizacionId: any, token: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `${token}`
        });
    
        return this.http.put(`${this.apiUrl}/penalyzation/Observations/${penalizacionId}`, penalizacion, { headers });
      }





}
